/* eslint-disable global-require */
module.exports = ['subscriptions.purchase.common.one-day-refound-info.m1'];
